import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import NoSSR from 'components/no-ssr'
import PageProgress from './page-progress'
import Head from './head'
import { Footer } from './footer'
import Header from './header'
import { global as GlobalStyles } from 'styles/global'
import * as theme from 'styles/theme'
import FormStyles from 'components/forms/form-styles'
// import AcquisitionPopup from './acquisition-popup'

const queryClient = new QueryClient()

/**
 * @typedef LayoutProps
 * @property {('default'|'light'|'white')} [kind=default]
 * @property {React.ReactElement} children
 */

/**
 *
 * @type {import('react').FC<LayoutProps>}
 */
const Layout = props => {
  const { children, kind = 'default' } = props
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <GlobalStyles />
        <FormStyles />
        <SkipToContent href='#main'>Skip to content</SkipToContent>
        <PageBody>
          <Head />
          <NoSSR>
            <PageProgress />
          </NoSSR>
          {/* <AcquisitionPopup /> */}
          <Header kind={kind} />
          <Main id='main' tabIndex='-1'>
            <PageContent kind={kind}>
              {children}
            </PageContent>
          </Main>
          <Footer kind={kind} />
        </PageBody>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const PageBody = styled.div`
  margin: 0 auto;
  max-width: 1366px;
  position: relative;
`

const SkipToContent = styled.a`
  background: #000;
  color: #fff;
  font-size: 16px;
  height: 1px;
  left: -1000px;
  overflow: hidden;
  padding: 10px 15px;
  position: absolute;
  text-decoration: none;
  top: -1000px;
  width: 1px;

  :active,
  :focus,
  :hover {
    height: auto;
    left: 10px;
    overflow: visible;
    top: 10px;
    width: auto;
    z-index: 9999;
  }
`

const Main = styled.main`
  outline: none;
`

const PageContent = styled.div`
  background-color: ${props => (props.kind === 'light' ? theme.color.n10 : '#fff')};
`

export default Layout
